<template>
    <div>
        <div class="card">
            <div class="header">修改密码</div>
            <div class="card-txt">
                <el-form :model="model" :rules="rules" label-width="100px" ref="loginForm">
                    <el-form-item label="旧密码" prop="oldPassword" class="m-t-20">
                        <el-input v-model="model.oldPassword" type="password" maxlength="32" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="password">
                        <el-input v-model="model.password" type="password" maxlength="32" placeholder="请输入6-32位新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="confirmPassword">
                        <el-input v-model="model.confirmPassword" type="password" maxlength="32" placeholder="请再次输入新密码"></el-input>
                    </el-form-item>
                </el-form>
                <div class="btn">
                    <button @click="save">立即修改</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'password',
        data () {
            return {
                loading:false,
                model: {
                    oldPassword: '',
                    password: '',
                    confirmPassword:''
                },
                rules: {
                    oldPassword: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                        { min: 6, max: 32, message: '请输入6-32位旧密码', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { min: 6, max: 32, message: '请输入6-32位新密码', trigger: 'blur' }
                    ],
                    confirmPassword: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(value !== this.model.password){
                                    callback(new Error('两次输入的密码不一致'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                }
            }
        },
        methods: {
            save () {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading=true;
                        this.$axios.put('/api/services/app/User/UpdatePassword', this.model).then(res => {
                            this.loading=false;
                            if (res.success) {
                                this.$notify({
                                    title: '密码修改成功',
                                    message: '请重新登陆！',
                                    type: 'success',
                                    duration:2000
                                })
                                //this.$refs.regForm.resetFields();
                                this.$store.dispatch('userLogout');
                                this.$router.push({ path: '/login' })
                            } else {
                                this.$alert(res.error.message, '')
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        width: 600px;
        margin: 40px auto;
        box-shadow: 0 0 10px #ddd;

        .header {
            font-size: 18px;
            padding: 20px 30px;
            border-bottom: 1px solid #eee;
        }

        .card-txt {
            padding: 20px 30px;

            ::v-deep .el-input__inner {
                height: 44px;
                line-height: 44px;
            }

            ::v-deep .el-form-item {
                margin-bottom: 30px;
            }

            .btn{
                text-align: right;
                padding: 0 0 10px 0;
                button{
                    width: 120px;
                    height: 44px;
                    line-height: 44px;
                    background: #90ca6f;
                    color: white;
                }
            }
        }
    }

</style>
